import * as React from 'react';
import InsightsSlider from 'components/Insights/InsightsSlider';

const CardSlider = ({ title, link, linkText, source }) => {
	if (source === 'insights') {
		return <InsightsSlider title={title} link={link} linkText={linkText}/>
	}
	return null;
}

export default CardSlider;